// Shared utility for extracting a Renki tag serial from a scanned URL.
// Rules (per current backend contract):
//   - Allowed URLs always start with one of `allowedPrefixes`.
//   - Path structure after prefix is `/qr/<serial>` or `/nfc/<serial>`.
//   - `<serial>` may be a simple numeric id (e.g. "1") OR a hex/uid string (may contain colons).
//   - We normalize by lowercasing and stripping colons.
// Returns the normalized serial or null when not derivable.
import { allowedPrefixes } from './allowedUrls';

export function extractSerialFromUrl(url: string): string | null {
    if (!url) {
        return null;
    }
    try {
        const u = new URL(url);
        const full = u.toString();
        const prefix = allowedPrefixes.find((p) => full.startsWith(p));
        if (!prefix) {
            return null; // not a recognized base URL
        }
        // Split path and locate qr/nfc segment.
        const segments = u.pathname.split('/').filter(Boolean); // e.g. ['v1','qr','1']
        if (segments.length < 3) {
            return null; // expecting at least v1 + type + serial
        }
        const typeSegIndex = segments.findIndex((s) => s === 'qr' || s === 'nfc');
        if (typeSegIndex === -1) {
            return null;
        }
        const serialRaw = segments[typeSegIndex + 1];
        if (!serialRaw) {
            return null;
        }
        // Validate characters (digits, hex letters, optional colons) – allow length >=1.
        if (!/^[0-9A-Fa-f:-]+$/.test(serialRaw)) {
            return null;
        }
        return serialRaw.replaceAll(':', '').toLowerCase();
    } catch {
        return null;
    }
}
